<template>
    <div class="transport-info">
        <div class="transport-info-header">
            <icon :name="iconName" class="mr-8 mt-1" width="21px" height="20px" fill="var(--lighten-7-color)"/>
            <div class="transport-info-header-content">
                <h3 class="mb-3">{{localizeList[`${type}Transfer`]}}</h3>
                <p class="grey-text-small">
                    {{transportHeadline}}
                </p>
            </div>
        </div>
        <div class="transport-info-content">
            <div v-for="(item, key) in transportInfo"
                 :key="key"
                 class="transport-info-card mb-10 pb-10">
                <template v-if="trains[key]">
                    <div class="card-headline flex border-b mb-3">
                        <h3>{{getCardTitle(item)}}</h3>
                    </div>
                    <div :class="['card-content', `card-content-${key}`]">
                        <div v-for="(item2, key2) in trains[key]"
                             :key="key2">
                            <div class="train-title text-center mb-4" :class="{'mt-5': key2 }">
                                <span class="text-small">{{item2.Name}}</span>
                            </div>
                            <div :style="item2.trainWrapStyle"
                                 :class="['train-wrap', {'rotate': getOrientation(item2)}, {'rotate-outer': isHorizontal(item2)}]">
                                <div :class="['train', `train-${key2}`]"
                                     :style="item2.trainStyle" >
                                    <div v-for="(item3, key3) in getSeats(item2, key, key2)"
                                         :key="key3"
                                         ref="box"
                                         :style="item3.seatStyle"
                                         :class="item3.seatClass">
                                        <p v-show="item3.text !== 'П'" class="box-text">
                                            {{item3.text}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item2.Comment" class="justify-center">
                                <textarea v-model="item2.Comment" readonly resize="none" 
                                style="width: 96%; height: 60px; resize: none; margin-top: -10px; border: 1px solid lightgray; padding: 5px; outline:none;"/>
                            </div>    
                        </div>
                    </div>
                </template>
                <div v-else-if="loadTrain" class="align-center justify-center pt-10">
                    <base-loader size="50" weight="3" color="var(--dark-1-color)"/>
                </div>
                <template v-else>
                    <div class="card-headline flex border-b mb-10">
                        <h3>{{getCardTitle(item)}}</h3>
                    </div>
                    <p class="grey-text ml-10">{{localizeList.noSeatingPlan}}</p>
                </template>
            </div>

            <div class="transport_legend">
                <div class="seats">
                    <p class="flex">
                        <span class="quoteNo icon"></span>
                        <span>{{localizeList.isTaken}}</span>
                    </p>
                    <p class="flex">
                        <span class="quoteYes icon"></span>
                        <span>{{localizeList.free}}</span>
                    </p>
                    <p class="flex">
                        <span class="blockSeat icon"></span>
                        <span>{{localizeList.locked}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "transportInfo",
        data() {
            return {
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                PATH: this.$store.getters['getPath'],
                seatsInfo: [],
                loadTrain: false
            }
        },
        props: {
            transportInfo: {
                type: Array,
                default: () => []
            },
            type: {
                type: String,
                default: 'railway'
            }
        },
        computed: {
            iconName() {
                if (this.type === "bus") return "bus";
                if (this.type === "transfer") return "taxi";
                return "train";
            },
            trains() {
                const boxMargin = 2;
                const boxHeight = 22 + boxMargin;
                const trainMargin = 20;
                return this.seatsInfo.map(x => {
                    if (!x?.Seats?.length) return null;

                    return x.VehiclePlans.map(x2 => {
                        if (this.getOrientation(x2)) {
                            const height = Math.max(200, x2.Column * boxHeight);
                            x2.trainWrapStyle = [
                                { "height": `${height}px` },
                                { "margin": "0 auto 20px" },
                                { "width": `${(x2.Row + 2) * boxHeight + trainMargin * 2}px` }
                            ];
                            x2.trainStyle = [
                                { "transform": "rotate(-90deg)" },
                                { "border-bottom": "1px solid #c1bfbf" },
                                { "margin": "0" }
                            ];                            
                        }
                        return x2                        
                    })
                })
            },
            transportHeadline() {
                const typeUpper = this.type[0].toUpperCase() + this.type.slice(1);
                const first = this.localizeList[`placesIn${typeUpper}OnTour`];

                if (!first) return this.transportInfo[0].tourName;
                return `${first} "${this.transportInfo[0].tourName}"`
            }
        },
        mounted() {
            this.getTransportSeatsInfo()
        },
        methods: {
            getOrientation(item) {
                return (!item.PlanOrientation && item.Column < item.Row ||
                    item.PlanOrientation && item.Column > item.Row)
            },
            isHorizontal(item) {
                return item.Column > item.Row
            },
            getTransportSeatsInfo() {
                this.loadTrain = true;
                this.seatsInfo = [];
                
                let count = this.transportInfo.length;
                this.transportInfo.forEach((x, i) => {
                    const sendParams = {
                        code: x.code,
                        dateBegin: this.getDate(x.BeginDateTime),
                        serviceType: x.SvKey,
                        transportKey: x.transportKey
                    }

                    this.$store.dispatch('hotels/A_GET_TRANSPORT_SEATS_INFO', sendParams)
                        .then(res => {
                            this.$set(this.seatsInfo, i, res);

                            count--;
                            if (!count)
                                this.loadTrain = false;
                        })
                        
                })
            },
            getSeatClass(type) {
                if (type === 1 || type === "Seat") {
                    return "quoteYes";
                } else if (type === 4) {
                    return "blockSeat";
                } else if (type === 5) {
                    return "quoteNo";
                } else {
                    return "noneSeat";
                }
            },
            getSeats(item, key, key2) {
                const seats = this.seatsInfo[key].Seats.filter(x => x.VPKey === item.Key);
                if (!seats?.length) return [];

                const res = [];

                for (let r = 0; r < item.Row; r++) {
                    for (let c = 0; c < item.Column; c++) {
                        const box = {
                            seatStyle: {},
                            seatClass: "box",
                            text: "",
                        };
                        const index = r * item.Column + c;
                        const seat = seats.find(x => x.Index === index);
                        box.text = seat.Number;
                        box.seatClass += " seat " + this.getSeatClass(seat.SeatType);
                        if (seat.Border) {
                            box.seatStyle = {
                                borderTop: seat.Border[0] === "0" ? "" : `${seat.Border[0]}px solid rgb(80, 80, 80)`,
                                borderRight: seat.Border[1] === "0" ? "" : `${seat.Border[1]}px solid rgb(80, 80, 80)`,
                                borderBottom: seat.Border[2] === "0" ? "" : `${seat.Border[2]}px solid rgb(80, 80, 80)`,
                                borderLeft: seat.Border[3] === "0" ? "" : `${seat.Border[3]}px solid rgb(80, 80, 80)`,
                            };
                        }

                        res.push(box)
                    }
                }

                setTimeout(() => {
                    this.setColumnsStyle(item.Column, item.Row, key, key2)
                },0);

                return res
            },
            setColumnsStyle(columnsCount, rowsCount, key, key2) {
                const cardContent = document.querySelector(`.card-content-${key} .train-${key2}`);

                cardContent.style.gridTemplateColumns = `repeat(${parseInt(columnsCount)}, 1fr)`;
            },
            getDate(date) {
                return date.split('T')[0].split('-').reverse().join('.')
            },
            getCardTitle(item) {
                const cityFrom = this.type !== 'transfer' ? item.CityFrom.Value : item.City.Value;
                const cityTo = this.type !== 'transfer' ? item.CityTo.Value : "";

                if (!cityTo) return `${cityFrom} • ${this.getDate(item.BeginDateTime)}`;
                return `${cityFrom} – ${cityTo} • ${this.getDate(item.BeginDateTime)}`
            }
        },
        watch: {
            transportInfo() {
                this.getTransportSeatsInfo()
            }
        }
    }
</script>

<style scoped>
    .transport-info {
        /*width: 454px;*/
        min-width: 454px;
        background-color: var(--lighten-6-color);
        height: 100%;
    }
    .transport-info-header {
        background-color: var(--white-color);
        padding: 20px;
        display: flex;
        box-shadow: 0 1px 2px rgba(100,100,100,.2);
        position: relative;
    }
    .transport-info-header-content h3 {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: #1D1D1D;
    }
    .transport-info-content {
        padding: 28px;
        overflow-y: auto;
        height: calc(100% - 100px);
    }
    .transport-info-card {
        background-color: var(--white-color);
        border-radius: 6px;
    }
    .transport-info-card .card-headline {
        padding: 16px 16px 12px 16px;
    }
    .transport-info-card .card-headline h3{
        font-weight: 500;
        font-size: 15px;
        /*line-height: 38px;*/
        color: var(--dark-1-color);
    }

    .transport-info-card .card-content {
        max-width: 600px;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 10px;
    }

    .transport-info-card .card-content .train-wrap {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }
    .transport-info-card .card-content .train-wrap:not(:last-child) {
        margin-bottom: 20px;
    }

    .transport-info-card .card-content .train {
        position: relative;
        /*width: 200px;*/
        min-width: 200px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        border: 1px solid #c1bfbf;
        border-radius: 10px;
        padding: 8px;
    }
    .transport-info-card .card-content .rotate-outer .train {
        width: auto;
    }
    .transport-info-card .card-content .rotate-outer .train .seat {
        min-width: 22px;
    }
    .transport-info-card .card-content .train:after,
    .transport-info-card .card-content .train:before {
        content: "";
        position: absolute;
        left: 30%;
        right: 30%;
        height: 4px;
        background-color: #c1bfbf;
    }
    .transport-info-card .card-content .train:after {
        top: -4px;
    }
    .transport-info-card .card-content .train:before {
        bottom: -4px;
    }
    .transport-info-card .card-content .rotate-outer .train:after,
    .transport-info-card .card-content .rotate-outer .train:before {
        top: 30%;
        bottom: 30%;
        height: unset;
    }
    .transport-info-card .card-content .rotate-outer .train:after {
        left: -4px;
        right: 100%;
    }
    .transport-info-card .card-content .rotate-outer .train:before {
        right: -4px;
        left: 100%;
    }
    .transport-info-card .card-content .box {
        text-align: center;
        font-size: 11px;
        line-height: 22px;
        min-height: 22px;
        min-width: 22px;
    }
    .transport-info-card .card-content .rotate .box .box-text {
        transform: rotate(90deg);
    }
    .transport-info-card .card-content .seat {
        border: 1px solid #fff;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .transport_legend {
        margin-top: 20px;
    }

    .transport_legend .seats {
        padding-top: 15px;
    }

    .transport_legend .seats span.icon {
        display: inline-block;
        border: 1px solid #DFDFD0;
        width: 35px;
        height: 16px;
        margin: 0 10px 5px 0;
    }
    .transport_legend .seats span {
        line-height: 15px;
        font-size: 12px;
    }

    .quoteYes {
        background: linear-gradient(0deg,#91e8a2 0%, #75e98d 28%, #74e98d 41%, #d9eee3 100%);
        /*background: white url("../../../assets/images/quote_yes.png") left top repeat-x;*/
    }
    .rotate .quoteYes {
        background: linear-gradient(90deg,#fafdfb 0%, #74e98d 28%, #74e98d 41%, var(--white-color) 100%);
    }

    .quoteNo {
        background: linear-gradient(0deg,#f66c5e 0%, #fd4b3d 10%, #fab1ad 70%, #f9d5d5 100%);
        /*background: white url("../../../assets/images/quote_no.png") left top repeat-x;*/
    }
    .rotate .quoteNo {
        background: linear-gradient(90deg,#f66c5e 0%, #fd4b3d 10%, #fab1ad 70%, #f9d5d5 100%);
    }

    .blockSeat {
        background: linear-gradient(0deg,#797979 0%, #848484 10%, #cacaca 70%, var(--lighten-6-color) 100%);
        /*background: white url("../../../assets/images/block_seat.png") left top repeat-x;*/
    }
    .rotate .blockSeat {
        background: linear-gradient(90deg,#c1c1c1 0%, #848484 28%, #cacaca 67%, var(--lighten-6-color) 100%)
        /*background: linear-gradient(90deg,#797979 0%, #848484 10%, #cacaca 70%, var(--lighten-6-color) 100%);*/
    }
</style>
